import { render, staticRenderFns } from "./B-6-1-1__OfficeCreate.vue?vue&type=template&id=76c3a2ec&"
import script from "./B-6-1-1__OfficeCreate.vue?vue&type=script&lang=js&"
export * from "./B-6-1-1__OfficeCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VSpacer})
